module.exports = __webpack_public_path__ + "img/people.5893f50b.png";